import AdviserProjectSummaryDetails from "./components/AdviserProjectSummaryDetails";
import { Row } from "react-bootstrap";
import { Main } from "../../components/utilities";

const AdviserSummary = () => {

    return (
        <>
            <Main className="p-3">
                <Row className="p-2">
                    <AdviserProjectSummaryDetails />
                </Row>
            </Main>
        </>
    )
}

export default AdviserSummary;